import React, {ReactNode} from "react";
import {css} from "/src/utils/utils";

import * as styles from "./module-body.module.scss";

interface Props {
  children: ReactNode;
  classes?: string;
  id?: string;
}

const ModuleBody = React.forwardRef<HTMLDivElement, Props>(function ModuleBody(
  {children, classes = "", id},
  ref
) {
  return (
    <div id={id!} className={css(styles.body, classes)} ref={ref}>
      {children}
    </div>
  );
});

export default ModuleBody;
